import Counter from "../Components/Counter"
import MilIllustrationSlider from "../Components/MilIllustrationSlider";

export default function Multi() {
    const multiPhotos = [
        'assets/images/offer/multi/1.png',
        'assets/images/offer/multi/2.png',
        'assets/images/offer/multi/3.png',
        'assets/images/offer/multi/4.png',
    ];

    return(
      <div className="mil-wrapper">
        <div id="content">

          <section class="mil-banner mil-banner-sm">
            <img src="assets/images/background/background-5.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Tło budynki mieszkalne." style={{ objectPosition: "top" }} />
              <div class="container">
                <div class="mil-background-grid mil-top-space"></div>
                  <div class="mil-banner-content mil-center">
                    <div class="mil-mb-90">
                      <h1 class="mil-light mil-upper mil-mb-30">BUDOWNICTWO<br />WIELORODZINNE</h1>
                    </div>
                  </div>
              </div>
            </section>

          <section>
                <div class="container mil-p-120-60">
                    <div class="mil-background-grid mil-softened"></div>
                    <div class="row justify-content-between">
                        <div class="col-lg-7">

                            <h2 class="mil-upper mil-up mil-mb-60">Partner w realizacji inwestycji deweloperskich</h2>
                            <p class="mil-up mil-mb-30">Jesteśmy doświadczonym i zaufanym partnerem dla deweloperów i inwestorów. Specjalizujemy się w generalnym wykonawstwie budynków wielomieszkaniowych, osiedli i apartamentowców. Dzięki wieloletniej praktyce i udanej współpracy z wiodącymi deweloperami w regionie toruńskim, takimi jak Press, Lembud, Strabag, Kudlińscy czy Gramar, jesteśmy przygotowani do realizacji nawet najbardziej wymagających projektów. Zapewniamy profesjonalne zarządzanie budową, terminowość i najwyższą jakość wykonania.</p>
                            <div class="mil-divider-lg mil-up mil-mb-60"></div>

                            <h3 class="mil-upper mil-up mil-mb-60">Proces realizacji inwestycji</h3>
                            
                            <div class="col-lg-12">
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/01.png" alt="01 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Analiza projektu i optymalizacja</h5>
                                  <p>Na wczesnym etapie analizujemy dokumentację projektową, proponując optymalne rozwiązania technologiczne i materiałowe, które mogą wpłynąć na redukcję kosztów i przyspieszenie prac.</p>
                                 </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15" >
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/02.png" alt="02 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3" >
                                  <h5>Generalne wykonawstwo i harmonogram</h5>
                                  <p>Przejmujemy pełną odpowiedzialność za realizację budowy. Tworzymy szczegółowy harmonogram, zarządzamy logistyką, dostawami materiałów i pracą zespołów na placu budowy.</p>
                                  </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/03.png" alt="03 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Zarządzanie jakością i bezpieczeństwem</h5>
                                  <p>Stale monitorujemy jakość wykonywanych prac, zapewniając zgodność z projektem i normami budowlanymi. Priorytetem jest dla nas również utrzymanie najwyższych standardów BHP.</p>
                                </div>
                              </div>
                              <div class="d-flex align-items-center mil-mb-15">
                                <div class="flex-shrink-0">
                                  <img src="assets/images/icons/04.png" alt="04 numer" style={{ width:"70px"}} />
                                </div>
                                <div class="flex-grow-1 ms-3">
                                  <h5>Odbiory i przekazanie inwestycji</h5>
                                  <p>Po zakończeniu wszystkich robót, przygotowujemy kompletną dokumentację powykonawczą i uczestniczymy w procesie odbiorów, finalizując projekt i przekazując gotowy obiekt inwestorowi.</p>
                                </div>
                              </div>
                              
                            </div>


                        </div>
                        <div class="col-lg-5">

                            <div class="mil-sidebar-frame mil-mb-60">
                                <h2 class="mil-upper mil-up mil-mb-60">Inne usługi</h2>
                                <p class="mil-dark mil-mb-5">Budownictwo wielorodzinne</p>
                                <p class="mil-dark mil-mb-5">Budownictwo usługowo - przemysłowe</p>
                                <p class="mil-dark mil-mb-30">Realizacje</p>
                                
                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <div class="row sc-p-txt">
                                    <div class="col-6">
                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={1000} />+
                                            </h5>
                                            <p class="mil-dark">Wykonanych zleceń</p>
                                        </div>
                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={30} />+
                                            </h5>
                                            <p class="mil-dark">Doświadczonych pracowników</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                             <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={10} />+
                                            </h5>
                                            <p class="mil-dark">Lat doświadczenia</p>
                                        </div>

                                    </div>
                                    <div class="col-6">

                                        <div class="mil-counter-frame mil-up mil-mb-30">
                                            <h5 class="mil-mb-5 mil-accent">
                                               <Counter target={50000} />+
                                            </h5>
                                            <p class="mil-dark">Godzin <br />pracy</p>
                                        </div>

                                    </div>
                                </div>

                                <div class="mil-divider-lg mil-up mil-mb-30"></div>

                                <h6 class="mil-upper mil-up mil-mb-30">Kontakt</h6>
                                <p class="mil-dark mil-mb-30">Zapraszamy do kontaktu:<br />Pon - Piąt: 8:00 - 17:00</p>
                                <p class="mil-dark mil-mb-5">Waryńskiego 33/2, 87-100 Toruń</p>
                                <p class="mil-dark mil-mb-5">+48 534 727 286</p>
                                <p class="mil-dark mil-mb-5">biuro@holtyn-bud.pl</p>
                            </div>
                        </div>
                    </div>
                </div>
          </section>

          <section>
                <div class="container mil-p-120-90">
                    <div class="mil-background-grid mil-softened"></div>

                    <div class="mil-center mil-mb-90">
                        <h2 class="mil-upper mil-up">ZAKRES NASZYCH PRAC</h2>
                    </div>

                    <div class="row">
                        <div class="col-lg-4 mil-up">

                            <div  class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Generalne<br/>wykonawstwo</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Kompleksowe zarządzanie i realizacja całej inwestycji.</p> 
                                </div>
                            </div>

                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Stany<br/>surowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Solidne fundamenty, konstrukcje nośne i dach.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Prace żelbetowe <br/>i murowe</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Specjalistyczne konstrukcje o dużej skali i wytrzymałości.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Garaże podziemne<br/>i infrastruktura</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Budowa parkingów podziemnych i zagospodarowanie terenu.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Elewacje<br/>i termoizolacje</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Nowoczesne systemy ociepleń i wykończenia fasad.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mil-up">
                            <div class="mil-service-card mil-mb-30">
                                <div class="mil-center">
                                    <h4 class="mil-upper mil-mb-20">Koordynacja prac<br/>branżowych</h4>
                                    <div class="mil-divider-sm mil-mb-20"></div>
                                    <p class="mil-service-text">Zarządzanie podwykonawcami instalacji i wykończeń.</p>
                                </div>
                            </div>
                        </div>

                        </div>
                    </div>
        </section>

        <MilIllustrationSlider images={multiPhotos} />;

        </div>
      </div>
    )
}